import {GET_AUTH_SUCCESS} from "./types";

export const setAuth = data => dispatch => dispatch({
    type: GET_AUTH_SUCCESS,
    auth: data
});